<template>
  <div>
    <!-- Error -->
    <div class="error">
      <div class="error__content">
        <h2>{{ code }}</h2>
        <h3>{{ title }}</h3>
        <p>{{ description }}</p>
        <router-link to="/">
          <d-button pill>&larr; Voltar</d-button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
export default {
  name: "errors",
  data: function () {
    return {
      code: hasValue(this.$route.params.code) ? this.$route.params.code : "500",
      title: hasValue(this.$route.params.title)
        ? this.$route.params.title
        : "Ops... Algo saiu errado!",
      description: hasValue(this.$route.params.description)
        ? this.$route.params.description
        : "Houve um problema. Por favor tente novamente em alguns minutos.",
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/pages/errors.vue